import { LitElement as l, css as a, html as n } from "lit";
import { property as p } from "lit/decorators.js";
import { booleanType as f } from "../../../utils/property-types.js";
var u = Object.defineProperty, m = (r, t, e, o) => {
  for (var s = void 0, i = r.length - 1, d; i >= 0; i--)
    (d = r[i]) && (s = d(t, e, s) || s);
  return s && u(t, e, s), s;
};
class h extends l {
  constructor() {
    super(...arguments), this.disabled = !1;
  }
  static get styles() {
    return [
      a`
        :host {
          display: flex;
          flex-direction: column;
					align-items: flex-start;
          gap: var(--dss-spacing-xxs);
					width: 100%;
        }

				::slotted(*) {
					width: 100%;
				}
      `
    ];
  }
  get _formContent() {
    var e;
    const t = ((e = this.shadowRoot) == null ? void 0 : e.querySelector("slot")) || void 0;
    return this.requestUpdate(), t == null ? void 0 : t.assignedElements();
  }
  _propagateProperties() {
    if (this._formContent)
      for (const t of this._formContent)
        t.querySelectorAll("input").forEach((o) => {
          this.disabled ? o.setAttribute("disabled", "true") : o.removeAttribute("disabled");
        });
  }
  /* LIT LIFECYCLE */
  updated(t) {
    super.updated(t), t.has("disabled") && this._propagateProperties();
  }
  render() {
    return n` <slot></slot> `;
  }
}
m([
  p(f)
], h.prototype, "disabled");
export {
  h as CardForm
};
//# sourceMappingURL=card-form.js.map
